import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../Assets/css/inline-styles.css";
import UserInfo from "../../Hooks/UserInfo";
import { useDispatch, useSelector } from "react-redux";
import { getPackNotificationAction } from "../../Redux/Action/addOnPackAction";

export default function Sidebar({ isActive, setIsActive, setShow, show }) {
  const dispatch = useDispatch();
  const { notification } = useSelector((state) => state?.packsSlice);
  const currentPath = window.location.pathname;

  useEffect(() => {
    dispatch(getPackNotificationAction());
  }, []);

  const {
    categoriesPermission,
    tagPermission,
    faqPermission,
    supportPermission,
    notificationPermission,
    adminPermission,
  } = UserInfo();

  const [openSections, setOpenSections] = useState({
    content: [
      "/manage-content",
      "/manage-categories",
      "/manage-tags",
      "/manage-presenters",
      "/strategy-packs",
    ].includes(currentPath),
    organisations: [
      "/manage-schools",
      "/manage-organisation-groups",
      "/school-stats",
      "/requests",
    ].includes(currentPath) || currentPath.startsWith("/organisation-group/"),
    users: ["/teachers", "/students", "/parents"].includes(currentPath),
    support: ["/support", "/faqs", "/push-notifications"].includes(currentPath),
    account: ["/manage-admins", "/change-password"].includes(currentPath),
  });

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const isContentActive = [
    "/manage-content",
    "/manage-categories",
    "/manage-tags",
    "/manage-presenters",
    "/strategy-packs",
  ].includes(currentPath);
  const isOrganisationsActive = [
    "/manage-schools",
    "/manage-organisation-groups",
    "/school-stats",
    "/requests",
  ].includes(currentPath) || currentPath.startsWith("/organisation-group/");
  const isOrganisationGroupsRoute =
    currentPath === "/manage-organisation-groups" ||
    currentPath.startsWith("/organisation-group/");
  const isUsersActive = ["/teachers", "/students", "/parents"].includes(
    currentPath,
  );
  const isSupportActive = ["/support", "/faqs", "/push-notifications"].includes(
    currentPath,
  );
  const isAccountActive = ["/manage-admins", "/change-password"].includes(
    currentPath,
  );

  return (
    <aside>
      <div className="sidebar">
        <div className="logo-side">
          <img
            className="small"
            src={require("../../Assets/Images/C.png")}
            alt="Peerscroller compact logo"
          />
          <img
            className="big"
            src={require("../../Assets/Images/main-logo.png")}
            alt="Peerscroller logo"
          />
        </div>
        <div className="side-menu">
          <div>
            
            <div className="side-btm-space">
              <Link
                className={
                  currentPath === "/dashboard"
                    ? "menu-btn bar_active"
                    : "menu-btn"
                }
                to="/dashboard"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20px"
                  viewBox="0 -960 960 960"
                  width="20px"
                  fill="#a3aed0"
                >
                  <path d="M200-120q-33 0-56.5-23.5T120-200v-640h80v640h640v80H200Zm40-120v-360h160v360H240Zm200 0v-560h160v560H440Zm200 0v-200h160v200H640Z" />
                </svg>
                <p className="margin-0">Dashboard</p>
              </Link>
            </div>

            
            <div className="side-btm-space">
              <Link
                className={
                  isContentActive
                    ? "menu-btn bar_active sidebar-menu-link"
                    : "menu-btn sidebar-menu-link"
                }
                onClick={() => toggleSection("content")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20px"
                  viewBox="0 -960 960 960"
                  width="20px"
                  fill="#a3aed0"
                >
                  <path d="M680-160v-640q33 0 56.5 23.5T760-720v480q0 33-23.5 56.5T680-160ZM160-80q-33 0-56.5-23.5T80-160v-640q0-33 23.5-56.5T160-880h360q33 0 56.5 23.5T600-800v640q0 33-23.5 56.5T520-80H160Zm680-160v-480q25 0 42.5 17.5T900-660v360q0 25-17.5 42.5T840-240Zm-680 80h360v-640H160v640Zm0-640v640-640Z" />
                </svg>
                <p className="margin-0">Content</p>
                <span className="sidebar-submenu-arrow">
                  {openSections.content ? "▼" : "▶"}
                </span>
              </Link>
              {openSections.content && (
                <div>
                  <Link
                    className={
                      currentPath === "/manage-content"
                        ? "menu-btn ms-5 bar_active"
                        : "menu-btn ms-5"
                    }
                    to="/manage-content"
                  >
                    <p>Manage Content</p>
                  </Link>
                  <Link
                    className={
                      currentPath === "/manage-categories"
                        ? "menu-btn ms-5 bar_active"
                        : "menu-btn ms-5"
                    }
                    style={{ opacity: !categoriesPermission ? 0.3 : 1 }}
                    to={!categoriesPermission ? undefined : "/manage-categories"}
                  >
                    <p>Manage Categories</p>
                  </Link>
                  <Link
                    className={
                      currentPath === "/manage-tags"
                        ? "menu-btn ms-5 bar_active"
                        : "menu-btn ms-5"
                    }
                    style={{ opacity: !tagPermission ? 0.3 : 1 }}
                    to={!tagPermission ? undefined : "/manage-tags"}
                  >
                    <p>Manage Tags</p>
                  </Link>
                  <Link
                    className={
                      currentPath === "/manage-presenters"
                        ? "menu-btn ms-5 bar_active"
                        : "menu-btn ms-5"
                    }
                    style={{ opacity: !tagPermission ? 0.3 : 1 }}
                    to={!tagPermission ? undefined : "/manage-presenters"}
                  >
                    <p>Manage Presenters</p>
                  </Link>
                  <Link
                    className={
                      currentPath === "/strategy-packs"
                        ? "menu-btn ms-5 bar_active"
                        : "menu-btn ms-5"
                    }
                    to="/strategy-packs"
                  >
                    <p>Manage Strategy Packs</p>
                  </Link>
                </div>
              )}
            </div>

            
            <div className="side-btm-space">
              <Link
                className={
                  isOrganisationsActive
                    ? "menu-btn bar_active sidebar-menu-link"
                    : "menu-btn sidebar-menu-link"
                }
                onClick={() => toggleSection("organisations")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20px"
                  viewBox="0 -960 960 960"
                  width="20px"
                  fill="#a3aed0"
                >
                  <path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z" />
                </svg>
                <p className="margin-0">Organisations</p>
                <span className="sidebar-submenu-arrow">
                  {openSections.organisations ? "▼" : "▶"}
                </span>
                {notification?.showRequestNotificationDot && (
                  <span className="sidebar-notification-dot ms-2"></span>
                )}
              </Link>
              {openSections.organisations && (
                <div>
                  <Link
                    className={
                      currentPath === "/manage-schools"
                        ? "menu-btn ms-5 bar_active"
                        : "menu-btn ms-5"
                    }
                    to="/manage-schools"
                  >
                    <p>Manage Schools</p>
                  </Link>
                  <Link
                    className={
                      isOrganisationGroupsRoute
                        ? "menu-btn ms-5 bar_active"
                        : "menu-btn ms-5"
                    }
                    to="/manage-organisation-groups"
                  >
                    <p>Manage Organisation Groups</p>
                  </Link>
                  <Link
                    className={
                      currentPath === "/school-stats"
                        ? "menu-btn ms-5 bar_active"
                        : "menu-btn ms-5"
                    }
                    to="/school-stats"
                  >
                    <p>School Stats</p>
                  </Link>
                  <Link
                    className={
                      currentPath === "/requests"
                        ? "menu-btn ms-5 bar_active"
                        : "menu-btn ms-5"
                    }
                    to="/requests"
                  >
                    <p>Strategy Pack Requests</p>{" "}
                    {notification?.showRequestNotificationDot && (
                      <span className="sidebar-notification-dot ms-2"></span>
                    )}
                  </Link>
                </div>
              )}
            </div>

            
            <div className="side-btm-space">
              <Link
                className={
                  isUsersActive
                    ? "menu-btn bar_active sidebar-menu-link"
                    : "menu-btn sidebar-menu-link"
                }
                onClick={() => toggleSection("users")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20px"
                  viewBox="0 -960 960 960"
                  width="20px"
                  fill="#a3aed0"
                >
                  <path d="M367-527q-47-47-47-113t47-113q47-47 113-47t113 47q47 47 47 113t-47 113q-47 47-113 47t-113-47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm296.5-343.5Q560-607 560-640t-23.5-56.5Q513-720 480-720t-56.5 23.5Q400-673 400-640t23.5 56.5Q447-560 480-560t56.5-23.5ZM480-640Zm0 400Z" />
                </svg>
                <p className="margin-0">Users</p>
                <span className="sidebar-submenu-arrow">
                  {openSections.users ? "▼" : "▶"}
                </span>
              </Link>
              {openSections.users && (
                <div>
                  <Link
                    className={
                      currentPath === "/teachers"
                        ? "menu-btn ms-5 bar_active"
                        : "menu-btn ms-5"
                    }
                    to="/teachers"
                  >
                    <p>View Teachers</p>
                  </Link>
                  <Link
                    className={
                      currentPath === "/students"
                        ? "menu-btn ms-5 bar_active"
                        : "menu-btn ms-5"
                    }
                    to="/students"
                  >
                    <p>View Students</p>
                  </Link>
                  <Link
                    className={
                      currentPath === "/parents"
                        ? "menu-btn ms-5 bar_active"
                        : "menu-btn ms-5"
                    }
                    to="/parents"
                  >
                    <p>View Parents</p>
                  </Link>
                </div>
              )}
            </div>

            
            <div className="side-btm-space">
              <Link
                className={
                  isSupportActive
                    ? "menu-btn bar_active sidebar-menu-link"
                    : "menu-btn sidebar-menu-link"
                }
                onClick={() => toggleSection("support")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="20px"
                  viewBox="0 -960 960 960"
                  width="20px"
                  fill="#a3aed0"
                >
                  <path d="m480-80-10-120h-10q-142 0-241-99t-99-241q0-142 99-241t241-99q71 0 132.5 26.5t108 73q46.5 46.5 73 108T800-540q0 75-24.5 144t-67 128q-42.5 59-101 107T480-80Zm80-146q71-60 115.5-140.5T720-540q0-109-75.5-184.5T460-800q-109 0-184.5 75.5T200-540q0 109 75.5 184.5T460-280h100v54Zm-72-107q12-12 12-29t-12-29q-12-12-29-12t-29 12q-12 12-12 29t12 29q12 12 29 12t29-12Zm-58-115h60q0-30 6-42t38-44q18-18 30-39t12-45q0-51-34.5-76.5T460-720q-44 0-74 24.5T344-636l56 22q5-17 19-33.5t41-16.5q27 0 40.5 15t13.5 33q0 17-10 30.5T480-558q-35 30-42.5 47.5T430-448Zm30-65Z" />
                </svg>
                <p className="margin-0">Support</p>
                <span className="sidebar-submenu-arrow">
                  {openSections.support ? "▼" : "▶"}
                </span>
                {notification?.showReportNotificationDot && (
                  <span className="sidebar-notification-dot ms-2"></span>
                )}
              </Link>
              {openSections.support && (
                <div>
                  <Link
                    className={
                      currentPath === "/support"
                        ? "menu-btn ms-5 bar_active"
                        : "menu-btn ms-5"
                    }
                    style={{ opacity: !supportPermission ? 0.3 : 1 }}
                    to={!supportPermission ? undefined : "/support"}
                  >
                    <p>Support Tickets</p>
                    {notification?.showReportNotificationDot && (
                      <span className="sidebar-notification-dot ms-2"></span>
                    )}
                  </Link>
                  <Link
                    className={
                        currentPath === "/faqs"
                          ? "menu-btn ms-5 bar_active"
                          : "menu-btn ms-5"
                    }
                    style={{ opacity: !faqPermission ? 0.3 : 1 }}
                    to={!faqPermission ? undefined : "/faqs"}
                  >
                    <p>Manage FAQs</p>
                  </Link>
                  <Link
                    className={
                        currentPath === "/push-notifications"
                          ? "menu-btn ms-5 bar_active"
                          : "menu-btn ms-5"
                    }
                    style={{ opacity: !notificationPermission ? 0.3 : 1 }}
                    to={
                      !notificationPermission ? undefined : "/push-notifications"
                    }
                  >
                    <p>Push Notifications</p>
                  </Link>
                </div>
              )}
            </div>
          </div>

          
          <div>
            <div className="side-btm-last">
              <div className="side-btm-space">
                <Link
                  className={
                    isAccountActive
                      ? "menu-btn bar_active sidebar-menu-link"
                      : "menu-btn sidebar-menu-link"
                  }
                  onClick={() => toggleSection("account")}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="20px"
                    viewBox="0 -960 960 960"
                    width="20px"
                    fill="#a3aed0"
                  >
                    <path d="m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm70-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Zm-2-140Z" />
                  </svg>
                  <p className="margin-0">Account</p>
                  <span className="sidebar-submenu-arrow">
                    {openSections.account ? "▼" : "▶"}
                  </span>
                </Link>
                {openSections.account && (
                  <div>
                    <Link
                      className={
                        currentPath === "/manage-admins"
                          ? "menu-btn ms-5 bar_active"
                          : "menu-btn ms-5"
                      }
                      style={{ opacity: !adminPermission ? 0.3 : 1 }}
                      to={!adminPermission ? undefined : "/manage-admins"}
                    >
                      <p>Manage Admins</p>
                    </Link>
                    <Link
                      className={
                        currentPath === "/change-password"
                          ? "menu-btn ms-5 bar_active"
                          : "menu-btn ms-5"
                      }
                      to="/change-password"
                    >
                      <p>Change Password</p>
                    </Link>
                    <Link
                      className={
                        currentPath === "/"
                          ? "menu-btn ms-5 bar_active"
                          : "menu-btn ms-5"
                      }
                      onClick={() => {
                        localStorage.clear();
                        window.location.href = "/";
                      }}
                    >
                      <p>Log Out</p>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
